"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatPack = void 0;
/** @hidden */
exports.flatPack = function (object) {
    var result = {};
    var flatten = function (object, prevKey) {
        for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
            var origKey = _a[_i];
            var value = object[origKey];
            var flatKey = (prevKey ? prevKey + "." + origKey : origKey);
            if (value && typeof value === "object") {
                flatten(value, flatKey);
            }
            else {
                result[flatKey] = value;
            }
        }
    };
    flatten(object);
    return result;
};
//# sourceMappingURL=flat-pack.js.map